
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { singularityStore } from "@/store/store-accessor";
import Icon from "@/components/UI/Icon.vue";
import ColorSchemeCard from "./ColorSchemeCard.vue";
import { getPossibleColorSchemes } from "@/lib/singularity/brand/colors/schemes";
import { buildSchemeString } from "@/lib/singularity/brand/colors/utils";
import { PossibleColorSchemes } from "@/lib/singularity/brand/colors/types";

@Component({
  components: {
    Icon,
    ColorSchemeCard
  }
})
export default class ColorSchemePicker extends Vue {
  @Prop({ required: true })
  elementId!: number;

  @Prop({ default: "" })
  currentSchemeString!: string;

  @Prop({ required: true })
  category!: string;

  showGrid = false;

  get allSchemes(): PossibleColorSchemes {
    return getPossibleColorSchemes(singularityStore.brand.color);
  }

  get categorySchemes() {
    if (this.category === "primary") {
      return this.allSchemes.primary;
    } else if (this.category === "secondary1") {
      return this.allSchemes.secondary[0] || [];
    } else if (this.category === "secondary2") {
      return this.allSchemes.secondary[1] || [];
    } else if (this.category === "neutral") {
      return this.allSchemes.neutral;
    }
    return [];
  }

  get selectedIndex(): number {
    // Find the index of the currently selected scheme
    const currentIndex = this.categorySchemes.findIndex((_, index) => {
      return this.getSchemeString(index) === this.currentSchemeString;
    });
    return currentIndex >= 0 ? currentIndex : 0;
  }

  get currentScheme() {
    return this.categorySchemes[this.selectedIndex];
  }

  get currentSwatchStyle() {
    if (!this.currentScheme) return {};
    return {
      "--card-bg": this.currentScheme.background.value?.toString(),
      "--card-text": this.currentScheme.contrastedFromBackgroundForText.value?.toString()
    };
  }

  getSchemeString(index: number): string {
    return buildSchemeString(this.category as any, index);
  }

  onSliderChange(event: Event) {
    const target = event.target as HTMLInputElement;
    const index = parseInt(target.value);
    const scheme = this.categorySchemes[index];
    if (scheme) {
      this.selectScheme(this.getSchemeString(index), scheme);
    }
  }

  shuffleScheme() {
    const randomIndex = Math.floor(Math.random() * this.categorySchemes.length);
    const scheme = this.categorySchemes[randomIndex];
    if (scheme) {
      this.selectScheme(this.getSchemeString(randomIndex), scheme);
    }
  }

  toggleGrid() {
    this.showGrid = !this.showGrid;
  }

  close() {
    this.$emit("close");
  }

  selectScheme(schemeString: string, scheme: any) {
    this.$emit("select", schemeString, scheme);
  }
}
